<template>
  <list-content
      v-bind:rows-data="tableData"
      v-bind:columns="tableColumns"
      v-bind:add-label="pageContent.add_label"
      v-bind:title="pageContent.title"
      v-bind:new-uri="pageContent.newUri"
      v-bind:edit-uri="pageContent.editUri"
      v-bind:meta="meta"
      v-bind:show-message="showMessage"
      v-bind:message="message"
      @handlePageChange="handleCurrentChange"
      @handlepageSizeChange="handleSizeChange"
      @handleSearchData="performSearch"
      @handleDeleteData="handleDelete"
  ></list-content>
</template>

<script>
import LeadsService from "@/api/leads.service";
import ListContent from "@/components/LeadContent";

export default {
  name: "LEADS",
  components: {ListContent},
  data() {
    return {
      tableColumns: [
          {'key':'sender_name', 'label':'Name', 'sortable':true, 'is_image': false, 'width':''},
          {'key':'sender_email', 'label':'Email', 'sortable':true, 'is_image': false, 'width':''},
        {'key':'sender_phone', 'label':'Phone', 'sortable':true, 'is_image': false, 'width':200},
          {'key':'source', 'label':'Source', 'sortable':true, 'is_image': false, 'width':140},          
          {'key':'date', 'label':'Added On', 'sortable':true, 'is_image': false, 'width':140}
        
      ],
      pageContent: {
        'add_label': 'Add Lead',
        'title': 'Leads',
        'newUri': '/lead/add',        
        'editUri':'/lead/edit'
      },
      tableData: [],
      page: 1,
      search: [],
      filter_name:'',
      filter_source:'',
      filter_email: '',
      filter_phone:'',

      meta: Object,
      showMessage: false,
      message: {message:'', messageType:'success', effect:'dark'}
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      return LeadsService.leads(this.page, this.search, this.filter_name, this.filter_email, this.filter_phone, this.filter_source, this.pageSize).then(response => {
        this.meta = response.data.meta;
        this.tableData = response.data.data;
      });
    },
    performSearch(search) {
      this.search         = search.name;
      this.filter_name    = search.filter_name;
      this.filter_email   = search.filter_email;
      this.filter_phone   = search.filter_phone;
      this.filter_source  = search.filter_source;
      this.getTableData();
    },
    handleDelete(data) {
      let deleteRow = data.row;
      this.showMessage = false;
      if (data.indexNo >= 0) {
        return LeadsService.delete(deleteRow).then(response => {
          if(response.status === 201) {
            this.message.message = "Lead Article deleted successfully";
            this.message.messageType = "success";
            this.message.effect = "dark";
            this.showMessage = true;
            this.getTableData();
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.getTableData();
    },

  }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
</style>
